import { useQuery } from '@tanstack/react-query';
import { enterpriseApiClient } from '../../client';
import { WorkOrdersApi } from '../../openapi';
import type { WorkOrderViewModel } from '../../openapi';
import { workOrderKeys } from '../constants';
import { CACHE_TIMINGS } from '@api/constants';

export const useWorkOrder = (jobNumber: string, enabled = true) => {
  const workOrdersApi = new WorkOrdersApi(
    undefined,
    undefined,
    enterpriseApiClient
  );

  return useQuery<WorkOrderViewModel, Error>({
    queryKey: workOrderKeys.byJobNumber(jobNumber),
    queryFn: async () => {
      const response = await workOrdersApi.apiWorkOrdersJobNumberGet({
        jobNumber
      });
      return response.data;
    },
    enabled: enabled && !!jobNumber,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    ...CACHE_TIMINGS.WORK_ORDER
  });
};
